export default [
    [
        '#DFD6C4',
        '#EAF082',
        '#D7E9BC',
        '#26CDC5',
        '#44499E',
        '#DFD6C4',
        '#EAF082',
        '#D7E9BC',
    ],
    ['#D31900', '#FF6600', '#FFF2AF', '#7CB490', '#000000'],
    ['#294A62', '#3DACF0', '#E6FAF7', '#E2E200', '#FF6D27', '#F9FAFD'],
    [
        '#FC354C',
        '#29221F',
        '#13747D',
        '#0ABFBC',
        '#FCF7C5',
        '#FC354C',
        '#29221F',
        '#13747D',
    ],
    [
        '#ADADAD',
        '#A7F2EB',
        '#D6FFB0',
        '#FF9EB6',
        '#8A7886',
        '#ADADAD',
        '#A7F2EB',
        '#D6FFB0',
    ],
    [
        '#FFD012',
        '#ffffff',
        '#FFD012',
        '#ffffff',
        '#005DA5',
        '#ffffff',
        '#005DA5',
        '#ffffff',
    ],
]
